import { skipToken } from "@tanstack/react-query";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { elementRouter } from "@v2/trpc/routes/element";

const useListAllElementsMetadata = () => {
  const projectId = useCurrentProjectId();
  const { data, isLoading } = elementRouter.listAllElementsMetadata.useQuery(
    projectId ? { projectId } : skipToken,
  );

  return { data: data ?? [], isLoading };
};

export default useListAllElementsMetadata;
